import { combineReducers } from 'redux'
import uiFlags from './uiFlags'
import currentRecord from './currentRecord'

export default combineReducers({
  uiFlags,
  currentRecord,
})
